export default {
  "content": "<path class=\"path\" d=\"M23.333 0l-.213.04L16 2.8 8 0 .48 2.533a.672.672 0 00-.48.64v20.16A.66.66 0 00.667 24l.213-.04L8 21.2l8 2.8 7.52-2.533a.672.672 0 00.48-.64V.667A.66.66 0 0023.333 0zM16 22l-8-2.864V3l8 2.864V22z\" fill=\"#0065dc\" fill-rule=\"nonzero\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};